import { marqueeItems } from "../../data/portfolioData";

const Marquee = () => {
  const duplicatedItems = [...marqueeItems, ...marqueeItems];

  return (
    <div className="marquee-strip">
      <div className="marquee-inner">
        {duplicatedItems.map((item, index) => (
          <div className="marquee-item" key={`${item}-${index}`}>
            {item}
            <div className="dot" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
